<template>
  <div>
    <vx-card class="mb-8">
      <vs-row class=" w-ful mb-4 py-2">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title"><h5>검색기간</h5></vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-justify="left">
            <date-selector class="w-2/12"></date-selector>
            <span class="mx-4">~</span>
            <date-selector class="w-2/12"></date-selector>
          </vs-col>
        </vs-col>
      </vs-row>
      <vs-row class=" w-full mb-4">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title"><h5>검색엔진</h5></vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-justify="left">
            <vs-select autocomplete class="w-2/12" id="tableSelect" label=""  >
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in engine"/>
            </vs-select>
            <vs-button class="ml-auto w-2/12" color="secondary" >검색</vs-button>
          </vs-col>
        </vs-col>

      </vs-row>
    </vx-card>

    <vx-card class="line-card mb-8" noShadow cardBorder>
      <vs-table
        class="pb-wide"
        stripe
        ref="table"
        :data="accessPathList"

        :sst="true"
        :max-items="itemsPerPage">

        <template slot="thead">
          <vs-th class="" sort-key="groupName" >
            <vs-col vs-type="flex"  vs-justify="left" >
              No.
            </vs-col>
          </vs-th>
          <vs-th class="" sort-key="groupName" >
            <vs-col vs-type="flex"  vs-justify="center" >
              방문경로
            </vs-col>
          </vs-th>
          <vs-th class="" >
            <vs-col vs-type="flex"  vs-justify="center" >
              검색엔진
            </vs-col>
          </vs-th>
          <vs-th class="" >
            <vs-col vs-type="flex"  vs-justify="center" >
              접속자 수
            </vs-col>
          </vs-th>
          <vs-th class="th-fix-management" >
            <vs-col vs-type="flex"  vs-justify="center" >
              비율
            </vs-col>
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >

            <!-- NO. -->
            <vs-td >
              {{ indextr }}
            </vs-td>

            <!-- 방문경로 -->
            <vs-td class="text-center">
              {{ data[indextr].path }}
            </vs-td>

            <!-- 검색엔진 -->
            <vs-td class="text-center">
              {{ data[indextr].engine }}
            </vs-td>

            <!-- 접속자수 -->
            <vs-td class="text-center">
              {{ data[indextr].join }}
            </vs-td>

            <!-- 비율 -->
            <vs-td class="text-center">
              {{ data[indextr].r }}
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>

      <div class="vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination
            :total="(lastPage) ? lastPage : 1"
            v-model="currentPage" ></k-pagination>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import config from '/public/config'
import VueApexCharts from 'vue-apexcharts'
import DateSelector from '@/views/components/DateSelector'
import KPagination from '@/views/components/kPagination/kPagination'

export default {
  name: 'AccessPath',
  components: {
    KPagination,
    DateSelector,
    VueApexCharts
  },

  data () {

    return {
      engine: [
        { text: '엔진1', value: 10 },
        { text: '엔진2', value: 20 },
        { text: '엔진3', value: 50 }
      ],
      accessPathList: [
        {
          id: 1,
          path: `${config.BASE_URL}/`,
          engine: '기타',
          join: '40',
          r: '1,353%'
        },
        {
          id: 1,
          path: `${config.BASE_URL}/`,
          engine: '기타',
          join: '40',
          r: '1,353%'
        },
        {
          id: 1,
          path: `${config.BASE_URL}/`,
          engine: '기타',
          join: '40',
          r: '1,353%'
        },
        {
          id: 1,
          path: `${config.BASE_URL}/`,
          engine: '기타',
          join: '40',
          r: '1,353%'
        },
        {
          id: 1,
          path: `${config.BASE_URL}/`,
          engine: '기타',
          join: '40',
          r: '1,353%'
        },
        {
          id: 1,
          path: `${config.BASE_URL}/`,
          engine: '기타',
          join: '40',
          r: '1,353%'
        },
        {
          id: 1,
          path: `${config.BASE_URL}/`,
          engine: '기타',
          join: '40',
          r: '1,353%'
        },
        {
          id: 1,
          path: `${config.BASE_URL}/`,
          engine: '기타',
          join: '40',
          r: '1,353%'
        },
        {
          id: 1,
          path: `${config.BASE_URL}/`,
          engine: '기타',
          join: '40',
          r: '1,353%'
        },
        {
          id: 1,
          path: `${config.BASE_URL}/`,
          engine: '기타',
          join: '40',
          r: '1,353%'
        },
        {
          id: 1,
          path: `${config.BASE_URL}/`,
          engine: '기타',
          join: '40',
          r: '1,353%'
        },
        {
          id: 1,
          path: `${config.BASE_URL}/`,
          engine: '기타',
          join: '40',
          r: '1,353%'
        },
        {
          id: 1,
          path: `${config.BASE_URL}/`,
          engine: '기타',
          join: '40',
          r: '1,353%'
        },
        {
          id: 1,
          path: `${config.BASE_URL}/`,
          engine: '기타',
          join: '40',
          r: '1,353%'
        },
        {
          id: 1,
          path: `${config.BASE_URL}/`,
          engine: '기타',
          join: '40',
          r: '1,353%'
        }
      ],
      itemsPerPage: 10,
      lastPage : 10,
      currentPage : 1
    }

  }
}
</script>

<style>
.line-card .vx-card__collapsible-content .vx-card__body { padding: 0; }
.line-card .vs-row:first-child { background-color: #fff; font-weight: bold; border-top-left-radius: 1rem; border-top-right-radius: 1rem;}
.line-card .vs-row:last-child { background-color: #F9F9F9; border-bottom-left-radius: 1rem; border-bottom-right-radius: 1rem;}
</style>


<style scoped>
.fix-title { width:180px !important; }
.btn-icon { width:1.5rem; height:1.5rem;}

</style>
